import BasicCard from "@/components/BasicCard";
import H_LOGO from "@assets/logo/h_logo.png";
import { useTranslation } from "@vixi/localization";
import { RouteOptionsById, RouterIds, useNavigate } from "@vixi/router";
import { ButtonLink, GoBackBtn, Img, PageMainContent, useUiStore } from "@vixi/ui";
import ChevronRightCircle from "@assets/icons/chevron-right-circle.svg?react";
import { Button } from "@vixi/ui";
import { useEffect } from "react";

// Constants
const routeId = "/_app/premium/" satisfies RouterIds;

export const PremiumIndexPageOptions: RouteOptionsById<typeof routeId> = {
  component: RouteComponent,
};

// Pagination

const featureCards = [
  {
    key: "MoreAvatars" as const,
    img: (
      <div className="">
        <Img contain src="/images/featone.png" className= "w-[300px] h-[100px] scale-150" />
      </div>
    ),
  },
  {
    key: "UnlimitedCourses" as const,
    img: (
      <div className="">
        <Img contain src="/images/feattwo.webp" className= "w-[300px] h-[100px]" />
      </div>
    ),
  },
  {
    key: "ThemeTemplates" as const,
    img: (
      <div >
        <Img contain src="/images/featthree.png" className= "w-[300px] h-[100px]" />
      </div>
    ),
  },
  {
    key: "VoiceIntegration" as const,
    img: (
      <div >
        <Img contain src="/images/featfour.webp" className= "w-[300px] h-[100px]" />
      </div>
    ),
  },
];

function RouteComponent() {
  // useGoBack(null); used in the parent route
  const { t, byLocale } = useTranslation();
  const navigate = useNavigate();

  const {
    header: { setChildren: setHeaderChildren },
  } = useUiStore();

  {/*  useEffect(() => {
    setHeaderChildren(
      <GoBackBtn
        color="premium"
        onBack={() => {
          history.back();
        }}
      />,
    );

    return () => {
      setHeaderChildren(null);
    };
  }, []);
*/}
  return (
    <PageMainContent psY="small" className="bg-purple-100">
      {/* Logo + Title */}
      <div className=" bg-white border-2 border-premium rounded py-7.5 mx-[75px] flex justify-center items-center my-3.75 mx-[75px]">
        <div className="relative z-1100  flex items-end justify-center">
          <Img src={H_LOGO} alt="H Logo" width={149} height={69} />
          <h4 className="text-premium ar:mb-1 ms-3.5 ">{t("Premium.Title")}</h4>
        </div>
      </div>
     

      {/* Subtitle */}
      <h2 className="mx-auto mt-12.25 text-[24px] font-medium text-center text-black">{t("Premium.Subtitle")}</h2>

      {/* Link */}
      <div className="flex justify-center my-8.5">
      <Button
        variant="contained"
        color="premium"
        size="large"
        className="px-8 py-3 max-w-[233px] h-[33px] text-[18px] rounded-full bg-gradient-to-r from-purple-400 to-purple-600 hover:from-purple-500 hover:to-purple-700 text-white font-medium"
        startIcon={<ChevronRightCircle className="w-3 h-3" />}
        onClick={() => {
          useUiStore.getState().hideConfirmDialog();
          navigate({ to: "/premium/plans" });
        }}
      >
        {"Try Vixi Premium"}
        </Button>
        </div>

      {/* Features */}
      <div className="mx-auto mt-8 grid max-w-203 grid-cols-2 gap-x-21.5 gap-y-9.5">
        {featureCards.map((feature) => (
          <div key={feature.key} className="col-span-full md:col-span-1">
            <BasicCard
              usage="premium-feature"
              color="paper"
              icon={feature.img}
              title={t(`Premium.${feature.key}.Title`)}
              description={t(`Premium.${feature.key}.Description`)}
              disableHover
            />
          </div>
        ))}
      </div>
    </PageMainContent>
  );
}
